<template>
  <b-container class="container__page-explore-detail">
    <div v-if="fetching && !learningUnit" class="d-flex justify-content-center p-4 m-3">
      <b-spinner label="Loading..." variant="dark" />
    </div>

    <b-row v-else>
      <b-col cols="12">
        <base-bread-crumb :items="breadcrumbs" class="bg-white" />
      </b-col>

      <b-col v-if="learningUnit" cols="12" class="mb-3">
        <b-row class="align-items-start">
          <b-col ref="mc__detail" cols="12" md="7" align-self="stretch" class="mt-3">
            <div class="h-100 d-flex flex-column justify-content-between">
              <div>
                <div v-if="learningUnit.level_type" class="text-primary font-weight-bold">
                  <span class="mr-1"
                    ><img
                      :src="
                        learningUnit.level_type === 'CAREER_SPECIFIC'
                          ? require('@/assets/learning-unit-types/specific.svg')
                          : require('@/assets/learning-unit-types/academic.svg')
                      "
                      style="height: 16px"
                    />
                  </span>
                  <span class="text__mc-type">{{
                    learningUnit.level_type === 'CAREER_SPECIFIC'
                      ? 'Career Specific'
                      : 'Academic Focused'
                  }}</span>
                </div>
                <h1 class="font-weight-bold my-2 text__mc-title">
                  {{ name }}
                </h1>

                <base-text-editor-display v-if="learningUnit.description">
                  <div
                    v-safe-html="learningUnit.description"
                    class="container__text-mc-description"
                  ></div>
                </base-text-editor-display>
              </div>
              <div v-if="applyFetching">
                <b-spinner label="Loading..." variant="dark" />
              </div>

              <div v-else>
                <p v-if="isApplied" ref="bth__verify">
                  <b-button
                    variant="primary"
                    class="button__verify-competency mr-3 mt-3"
                    :to="verifyPage"
                    >Verify competency</b-button
                  >
                  <b-button
                    v-if="isApplied.mode == 'LEARN_VERIFY'"
                    variant="outline-primary"
                    class="button__go-to-learning mt-3"
                    :to="learnPage"
                    >Go to learning</b-button
                  >
                </p>
                <div v-else>
                  <b-button
                    :variant="eligible ? 'success' : 'secondary'"
                    class="button__apply-now"
                    :disabled="!eligible"
                    @click="scrollToMcVerify"
                    >Apply now</b-button
                  >

                  <span v-if="$_isFeatureEnabled('purchase_buynow')">
                    <button
                      v-if="activeContentCardVerify || activeContentCardLearnVerify"
                      :disabled="!eligible"
                      type="button"
                      variant="link"
                      class="btn btn-link button__redeem-code"
                      @click="onClickRedeemCode()"
                    >
                      Have a redeem code?
                    </button>
                  </span>

                  <b-spinner
                    v-if="checkingEligible"
                    label="checking apply eligible..."
                    variant="primary"
                    small
                  ></b-spinner>

                  <a
                    v-if="!checkingEligible && !eligible"
                    ref="tooltip"
                    v-b-tooltip.click.right.v-light
                    class="ml-3 icon__cannnot-apply-tool-tip"
                    :title="eligibleMessage"
                  >
                    <font-awesome-icon
                      icon="exclamation-circle"
                      size="lg"
                      style="color: #824224; cursor: pointer"
                    />
                  </a>
                </div>
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="5" align-self="stretch" class="mt-3 text-center">
            <base-video-player
              v-if="
                learningUnit.media_detail_vimeo &&
                learningUnit.media_detail_vimeo.video_link &&
                learningUnit.media_detail_vimeo.isVideoAvailable
              "
              :video="learningUnit.media_detail_vimeo"
              class="container__preview-video-detail"
              :width="500"
              :height="370"
              :options="{ responsive: false }"
            />

            <base-presigned-image
              v-else
              class="img-fluid img__detail_image mt-3"
              :file-id="mediaDetailFileId"
              :default-src="
                mediaDetailVideoThumbnailSrc
                  ? mediaDetailVideoThumbnailSrc
                  : require(learningUnit.media_detail_vimeo
                      ? '@/assets/default-video-cover.jpg'
                      : '@/assets/default-activity-cover.jpg')
              "
              public
            ></base-presigned-image>

            <!-- <img
              v-else-if="
                learningUnit.media_detail_vimeo &&
                !learningUnit.media_detail_vimeo.isVideoAvailable &&
                !learningUnit.media_detail_vimeo.sourceFile
              "
              :src="require('@/assets/default-video-cover.jpg')"
              alt=""
              class="img-fluid img__detail_image mt-3"
            />

            <img
              v-else-if="learningUnit.media_detail && learningUnit.media_detail[0]"
              :src="learningUnit.media_detail[0].url"
              alt=""
              class="img-fluid img__detail_image mt-3"
            />

            <img
              v-else
              :src="require('@/assets/default-activity-cover.jpg')"
              alt=""
              class="img-fluid img__detail_image mt-3"
            /> -->
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" class="mb-3">
        <hr />
      </b-col>

      <b-col v-if="learningUnit && learningUnit.competency_overview" cols="12" class="mb-5">
        <h2 class="font-weight-bold mb-2">Overview</h2>

        <base-text-editor-display>
          <div
            v-safe-html="learningUnit.competency_overview"
            class="container__text-competency-overview"
          ></div>
        </base-text-editor-display>
      </b-col>

      <b-col v-if="learningUnit && learningUnit.competency_detail" cols="12" class="mb-5">
        <h2 class="font-weight-bold mb-2">Competency</h2>
        <base-text-editor-display>
          <div
            v-safe-html="learningUnit.competency_detail"
            class="container__text-competency"
          ></div>
        </base-text-editor-display>
      </b-col>

      <b-col v-if="learningUnit && learningUnit.competency_how" cols="12" class="mb-4">
        <h2 class="font-weight-bold mb-2">How ?</h2>

        <base-text-editor-display>
          <div
            v-safe-html="learningUnit.competency_how"
            class="container__text-how-to-verify"
          ></div>
        </base-text-editor-display>
      </b-col>

      <b-col cols="12" class="mb-3">
        <hr />
      </b-col>

      <b-col v-if="showCardDetailLearn || showCardDetailVerify" cols="12" class="mb-4">
        <div class="card card__detail-mc w-100 shadow-sm py-4 px-4 text-white bg-plum-plate">
          <b-tabs pills nav-class="nav-line" content-class="">
            <b-tab v-if="showCardDetailVerify" title="Verify" lazy active>
              <template slot="title">
                <h3 ref="title" class="font-weight-bold active span__publication-todo-tab">
                  Verify
                </h3>

                <div class="divider" />
              </template>

              <hr style="border-top: 1px solid white" />

              <div class="tab__detail-mc">
                <h3 class="font-weight-bold mb-4">Method overview</h3>

                <base-text-editor-display v-if="learningUnit && learningUnit.method_overview">
                  <div v-safe-html="learningUnit.method_overview" class="text__lu-overview"></div>
                </base-text-editor-display>

                <hr style="border-top: 1px solid white" />

                <h3 class="font-weight-bold mb-4">How can you achieve ?</h3>

                <base-text-editor-display v-if="learningUnit && learningUnit.how_achieve">
                  <div v-safe-html="learningUnit.how_achieve" class="text__lu-overview"></div>
                </base-text-editor-display>
              </div>
            </b-tab>

            <b-tab v-if="showCardDetailLearn" title="Learn" lazy>
              <template slot="title">
                <h3 ref="title" class="font-weight-bold active span__publication-todo-tab">
                  Learn
                </h3>

                <div class="divider" style="color: #ffff" />
              </template>

              <hr style="border-top: 1px solid white" />

              <div class="tab__detail-mc">
                <h3 class="font-weight-bold mb-4">Learning unit overview</h3>

                <base-text-editor-display v-if="learningUnit && learningUnit.summary_overview">
                  <div v-safe-html="learningUnit.summary_overview" class="text__lu-overview"></div>
                </base-text-editor-display>

                <hr style="border-top: 1px solid white" />

                <h3 class="font-weight-bold mb-4">Outcomes</h3>

                <base-text-editor-display v-if="learningUnit && learningUnit.summary_outcome">
                  <div
                    v-safe-html="learningUnit.summary_outcome"
                    class="text__learning-outcomes"
                  ></div>
                </base-text-editor-display>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>

      <b-col v-if="showCardDetailLearn || showCardDetailVerify" cols="12" class="mb-3">
        <hr />
      </b-col>

      <b-col cols="12" class="mb-4">
        <div id="section-buy-now" ref="card__buy-now" class="col-md-10 mx-auto">
          <div
            v-if="activeContentCardVerify || activeContentCardLearnVerify"
            class="row no-gutters"
          >
            <card-mc-detail
              v-if="learningUnit"
              key="verify"
              ref="card_mc-detail-verify"
              :title="verifyTitle"
              :sub-title="verifyText"
              :mc="learningUnit"
              :hilight="!activeContentCardLearnVerify"
              :open-to-apply="activeContentCardVerify"
              :user="$currentUser"
              :price="learningUnit.price_verify"
              :discount-price="learningUnit.price_verify_discount"
              mode="VERIFY"
              :order="1"
              class="col-12 col-lg-6"
              :eligible="eligible"
              :eligible-message="eligibleMessage"
              @apply-fetching="applyFetching"
            >
              <template slot="footer">
                <ul class="list-unstyled text-left mt-5 mb-4 font-weight-bold">
                  <li
                    v-for="(can, index) in canDo"
                    :key="can"
                    class="py-2 d-flex flex-row align-items-baseline"
                  >
                    <div>
                      <b-img
                        v-if="isCanDo[index]"
                        :ref="`icon__card-mc-verify-${index}`"
                        :title="`IconCardVerify_${index}`"
                        class="mr-2"
                        :src="
                          activeContentCardLearnVerify
                            ? srcIconCardBlue[index]
                            : srcIconCardWhite[index]
                        "
                      ></b-img>
                    </div>

                    <div v-if="isCanDo[index]">{{ can }}</div>
                  </li>
                </ul>
              </template>
            </card-mc-detail>

            <card-mc-detail
              v-if="learningUnit"
              key="learn_Verify"
              ref="card_mc-detail-learn"
              :mc="learningUnit"
              :title="activeContentCardLearnVerify ? learnTitle : null"
              :sub-title="activeContentCardLearnVerify ? learnText : null"
              :hilight="activeContentCardLearnVerify"
              :open-to-apply="activeContentCardLearnVerify"
              :user="$currentUser"
              :price="learningUnit.price_verify_learn"
              :discount-price="learningUnit.price_verify_learn_discount"
              mode="LEARN_VERIFY"
              :order="2"
              :interest-modes="['LEARN']"
              class="col-12 col-lg-6"
              :eligible="eligible"
              :eligible-message="eligibleMessage"
              @apply-fetching="applyFetching"
            >
              <template slot="title">
                <div v-if="!activeContentCardLearnVerify">
                  <h3 class="font-weight-bold py-5">Learning unit will be coming soon!</h3>
                </div>
              </template>

              <template slot="sub-title">
                <p v-if="!activeContentCardLearnVerify" class="py-5">
                  We will let you know once the learning unit of this micro-credential is ready.
                </p>
              </template>

              <template slot="footer">
                <ul
                  v-if="activeContentCardLearnVerify"
                  class="list-unstyled text-left mt-5 mb-4 font-weight-bold"
                >
                  <li
                    v-for="(can, index) in canDo"
                    :key="can"
                    class="py-2 d-flex flex-row align-items-baseline"
                  >
                    <div>
                      <b-img
                        :ref="`icon__card-mc-learn-verify-${index}`"
                        :title="`IconCardLearnVerify_${index}`"
                        class="mr-2"
                        :src="srcIconCardWhite[index]"
                      ></b-img>
                    </div>
                    <div>{{ can }}</div>
                  </li>
                </ul>
              </template>
            </card-mc-detail>
          </div>

          <div v-else class="row no-gutters">
            <b-col cols="12">
              <card-mc-detail
                v-if="learningUnit"
                key="no_plan"
                ref="card_mc-detail-no_plan"
                title="Micro-Credentials"
                sub-title=""
                :mc="learningUnit"
                :hilight="false"
                :open-to-apply="false"
                :user="$currentUser"
                :order="1"
                :interest-modes="['LEARN', 'VERIFY']"
                :eligible="eligible"
                :eligible-message="eligibleMessage"
                @apply-fetching="applyFetching"
              >
                <template slot="title">
                  <label class="text-black-50 font-weight-bold mb-u16"> Micro-credential </label>
                </template>
                <template slot="body">
                  <h4 class="mb-u4">
                    <b> Competency verification and learning unit will be coming soon! </b>
                  </h4>

                  <p class="mb-u16">We will let you know once this micro-credential is ready.</p>
                </template>
              </card-mc-detail>
            </b-col>
          </div>
        </div>
      </b-col>

      <b-col cols="12" class="mb-3">
        <hr />
      </b-col>

      <b-col cols="12" class="mb-4">
        <h2 v-if="learningUnit && learningUnit.level_type" class="font-weight-bold mb-4">
          What will you get ?
        </h2>
        <b-row class="justify-content-center align-items-center">
          <b-col class="text-center" cols="12" sm="4" md="2">
            <base-presigned-image
              v-if="learningUnit && learningUnit.badge_image && learningUnit.badge_image[0]"
              class="img__badge"
              :file-id="badgeImageFileId"
              public
            ></base-presigned-image>
          </b-col>

          <b-col cols="12" sm="8" md="7">
            <p
              v-if="learningUnit && learningUnit.level_type"
              class="font-weight-bold font-size-lg mt-4"
            >
              {{
                learningUnit.level_type === 'CAREER_SPECIFIC'
                  ? 'Digital Badge'
                  : 'Digital Certificate'
              }}
            </p>
            <p class="font-size-lg">{{ name }}</p>
            <p class="m-0">
              <label
                ><span class="text-black-50">Issued by </span> KMUTT
                <span class="text-black-50"
                  >| You will earn this
                  <span v-if="learningUnit && learningUnit.level_type">
                    {{
                      learningUnit.level_type === 'CAREER_SPECIFIC'
                        ? 'digital badge'
                        : 'digital certificate'
                    }}
                  </span>
                  <span v-else>digital badge</span>
                  after you have completed this Micro - credential.</span
                >
              </label>
            </p>
            <ul v-if="learningUnit && learningUnit.level_type" class="list-unstyled text-left">
              <li
                v-for="(text, index) in learningUnit.level_type === 'CAREER_SPECIFIC'
                  ? careerSpecific
                  : academicFocused"
                :key="index"
                class="py-2 d-flex flex-row align-items-baseline"
              >
                <div>
                  <font-awesome-icon icon="check" class="text-success font-size-md mr-2" />
                </div>
                <div>{{ text }}</div>
              </li>
            </ul>

            <div></div>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" class="mb-3">
        <hr />
      </b-col>



      <b-col cols="12">
        <h2 class="font-weight-bold mb-3">Who is this for ?</h2>

        <base-text-editor-display v-if="learningUnit && learningUnit.who_this_for">
          <div v-safe-html="learningUnit.who_this_for" class="container__text-target-learner"></div>
        </base-text-editor-display>
      </b-col>

      <b-col cols="12" class="mb-3">
        <hr />
      </b-col>

      <b-col
        v-if="
          learningUnit &&
          (learningUnit.content ||
            learningUnit.content_media_vimeo ||
            (learningUnit.content_media && learningUnit.content_media[0]))
        "
        cols="12"
        class="mb-4"
      >
        <h2 class="font-weight-bold mb-3">Preview this course</h2>

        <b-row class="align-items-start">
          <b-col v-if="learningUnit && learningUnit.content" cols="12" md="6" align-self="stretch">
            <base-text-editor-display>
              <div
                v-safe-html="learningUnit.content"
                class="box__content mt-3 container__text-content-example"
              ></div>
            </base-text-editor-display>
          </b-col>
          <b-col
            v-if="
              learningUnit &&
              (learningUnit.content_media_vimeo ||
                (learningUnit.content_media && learningUnit.content_media[0]))
            "
            cols="12"
            md="6"
            align-self="stretch"
            class="my-auto"
          >
            <base-video-player
              v-if="
                learningUnit &&
                learningUnit.content_media_vimeo &&
                learningUnit.content_media_vimeo.video_link &&
                learningUnit.content_media_vimeo.isVideoAvailable
              "
              :video="learningUnit.content_media_vimeo"
              class="mt-3 container__preview-video-content"
              :width="568"
              :height="321"
              :options="{ responsive: false }"
            />

            <base-presigned-image
              v-else
              class="img__content_image mt-3"
              :file-id="contentMediaFileId"
              :default-src="
                contentMediaVideoThumbnailSrc
                  ? contentMediaVideoThumbnailSrc
                  : require(learningUnit.content_media_vimeo
                      ? '@/assets/default-video-cover.jpg'
                      : '@/assets/default-activity-cover.jpg')
              "
              public
            ></base-presigned-image>

            <!-- <img
              v-else-if="
                learningUnit &&
                learningUnit.content_media_vimeo &&
                !learningUnit.content_media_vimeo.isVideoAvailable &&
                !learningUnit.content_media_vimeo.sourceFile
              "
              :src="require('@/assets/default-video-cover.jpg')"
              alt=""
              class="img__content_image mt-3"
            />

            <img
              v-else-if="
                learningUnit && learningUnit.content_media && learningUnit.content_media[0]
              "
              :src="learningUnit.content_media[0].url"
              alt=""
              class="img__content_image mt-3"
            />

            <img
              v-else
              :src="require('@/assets/default-activity-cover.jpg')"
              alt=""
              class="img__content_image mt-3"
            /> -->
          </b-col>
        </b-row>
      </b-col>

      <b-col
        v-if="
          learningUnit &&
          (learningUnit.content ||
            learningUnit.content_media_vimeo ||
            (learningUnit.content_media && learningUnit.content_media[0]))
        "
        cols="12"
        class="mb-3"
      >
        <hr />
      </b-col>

      <b-col cols="12" class="mb-5">
        <h2 class="font-weight-bold mb-2">Who developed this?</h2>

        <b-row>
          <b-col cols="8" offset="2" sm="4" offset-sm="0" class="py-2 text-center">
            <base-presigned-image
              v-if="learningUnit && learningUnit.developer_media && learningUnit.developer_media[0]"
              class="img-fluid img__developer_image"
              :file-id="developerMediaFileId"
              public
            ></base-presigned-image>

            <!-- <img
              v-if="learningUnit && learningUnit.developer_media && learningUnit.developer_media[0]"
              :src="learningUnit.developer_media[0].url"
              alt=""
              class="img-fluid img__developer_image"
            /> -->
          </b-col>
          <b-col sm="8" class="pt-4 pb-2">
            <h3
              v-if="learningUnit && learningUnit.developer_name"
              class="text__developer-name font-weight-bold"
            >
              {{ learningUnit.developer_name }}
            </h3>

            <base-text-editor-display v-if="learningUnit && learningUnit.developer_detail">
              <div
                v-safe-html="learningUnit.developer_detail"
                class="container__text-developer-detail"
              ></div>
            </base-text-editor-display>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <redeem-code-modal
      :show.sync="activeModalRedeem"
      :redeem-type="'ENTRY'"
      :mc-id="learningUnitId"
      :success-alert-message="successAlertMessage"
      @redeem-success:hide="onCloseModalRedeem"
    ></redeem-code-modal>
  </b-container>
</template>

<script>
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
import BaseVideoPlayer from '@/components/base-components/BaseVideoPlayer';
import LearningUnit from '@/models/LearningUnit';
import Application from '@/models/Application';
import Interest from '@/models/Interest';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import { learningUnitInfoMixin } from '@/mixins/learningUnitInfoMixin';
import { notificationMixin } from '@/mixins/notificationMixin';
import Section from '@/models/Section';
import CardMcDetail from './components/CardMcDetail.vue';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';
import BasePresignedImage from '@/components/base-components/BasePresignedImage.vue';
import RedeemCodeModal from '@/components/LearningUnit/RedeemCodeModal.vue';

import { optimizelyMixin } from '@/mixins/optimizelyMixin';

export default {
  components: {
    BaseBreadCrumb,
    BaseVideoPlayer,
    CardMcDetail,
    BaseTextEditorDisplay,
    BasePresignedImage,
    RedeemCodeModal
  },
  mixins: [userInfoMixin, learningUnitInfoMixin, notificationMixin, optimizelyMixin],

  data() {
    return {
      isLoading: false,
      fetching: false,
      applyFetching: false,
      interestFetching: false,
      isCanDo: [1, 1, 1, 1, 1, 0, 0],
      activeModalRedeem: false,
      successAlertMessage: 'Code redeemed successfully.',
      verifyTitle: 'Verify your skill',
      verifyText: 'Make your Skills Recognizable and Impactful',
      learnTitle: 'Build your skill + Verify',
      learnText: 'One Step Closer to a Better Future',
      checkingEligible: false,
      eligible: true,
      eligibleMessage: '',
      careerSpecific: [
        'Show your real works as the competency evidence',
        'Sharable with an attachment of assessor’s recommendation letter',
        'Verified by educational / industrial experts'
      ],
      academicFocused: [
        'Sharable with the showcase of your name and the accomplished learning outcome',
        'Verified by educational / industrial experts'
      ],

    };
  },

  computed: {
    srcIconCardBlue() {
      return [
        require('../../assets/icon-card-mc-detail/blue/icon_card_b_1.png'),
        require('../../assets/icon-card-mc-detail/blue/icon_card_b_2.png'),
        require('../../assets/icon-card-mc-detail/blue/icon_card_b_3.png'),
        require(this.learningUnit?.level_type === 'CAREER_SPECIFIC'
          ? '../../assets/icon-card-mc-detail/blue/icon_card_b_4.png' // Digital Badge
          : '../../assets/icon-card-mc-detail/blue/icon_card_b_6.png'), // Digital Certificate
        require('../../assets/icon-card-mc-detail/blue/icon_card_b_5.png')
      ];
    },
    srcIconCardWhite() {
      return [
        require('../../assets/icon-card-mc-detail/white/icon_card_w_1.png'),
        require('../../assets/icon-card-mc-detail/white/icon_card_w_2.png'),
        require('../../assets/icon-card-mc-detail/white/icon_card_w_3.png'),
        this.learningUnit?.level_type === 'CAREER_SPECIFIC'
          ? require('../../assets/icon-card-mc-detail/white/icon_card_w_4.png') // Digital Badge
          : require('../../assets/icon-card-mc-detail/white/icon_card_w_8.png'), // Digital Certificate
        require('../../assets/icon-card-mc-detail/white/icon_card_w_5.png'),
        require('../../assets/icon-card-mc-detail/white/icon_card_w_6.png'),
        require('../../assets/icon-card-mc-detail/white/icon_card_w_7.png')
      ];
    },
    canDo() {
      return [
        'Unlimited Access to Competency Guidelines',
        '2 Submission Quotas to Verify Competency',
        'Personalized Feedback',
        this.learningUnit?.level_type === 'CAREER_SPECIFIC'
          ? 'Digital Badge'
          : 'Digital Certificate',
        'Shareable to Social Network',
        'Online Learning Videos from Expert',
        'Interactive Expert Community'
      ];
    },
    learningUnitId() {
      let parsedId;

      const { params, query } = this.$route;

      const { learningUnitId } = params,
        { id } = query;

      if (learningUnitId) {
        parsedId = parseInt(learningUnitId);
      } else if (id) {
        parsedId = parseInt(id);
      }

      return parsedId;
    },

    defaultSection() {
      return Section.query()
        .where('learning_unit_id', this.learningUnitId)
        .where('is_default', true)
        .first();
    },

    userId() {
      return this.$currentUser ? this.$currentUser.id : null;
    },

    breadcrumbs() {
      const { name } = this;
      return [
        {
          key: 'explore',
          name: 'Explore',
          to: {
            name: 'learning-unit'
          }
        },
        {
          key: 'micro-credentials/detail',
          name,
          active: true
        }
      ];
    },

    isApplied() {
      return Application.query()
        .where((apply) => {
          return apply.user.id == this.userId && apply.learning_unit.id == this.learningUnitId;
        })
        .first();
    },

    showCardDetailVerify() {
      return (
        this.learningUnit &&
        Boolean(this.learningUnit.method_overview) &&
        Boolean(this.learningUnit.how_achieve)
      );
    },

    showCardDetailLearn() {
      return (
        this.learningUnit &&
        Boolean(this.learningUnit.summary_overview) &&
        Boolean(this.learningUnit.summary_outcome)
      );
    },

    verifyPage() {
      const { learningUnitId } = this;

      return {
        name: 'learning-unit/method-components',
        params: {
          learningUnitId
        }
      };
    },

    learnPage() {
      const { learningUnitId } = this;

      return {
        name: 'learning-unit/feed',
        params: {
          learningUnitId,
          sectionId: this.defaultSection.id
        }
      };
    },

    activeContentCardVerify() {
      return (
        (this.learningUnit && this.learningUnit.open_apply_verify) ||
        (this.isApplied && this.isApplied.mode == 'VERIFY') ||
        (this.isApplied && this.isApplied.mode == 'LEARN_VERIFY')
      );
    },

    activeContentCardLearnVerify() {
      return (
        (this.learningUnit && this.learningUnit.open_apply_learn) ||
        (this.isApplied && this.isApplied.mode == 'LEARN_VERIFY')
      );
    },

    mediaDetailFileId() {
      if (
        this.learningUnit &&
        this.learningUnit.media_detail &&
        this.learningUnit.media_detail[0]
      ) {
        return this.learningUnit.media_detail[0].id;
      }
      return null;
    },
    mediaDetailVideoThumbnailSrc() {
      if (
        this.learningUnit &&
        this.learningUnit.media_detail_vimeo &&
        this.learningUnit.media_detail_vimeo[0]
      ) {
        return this.learningUnit.media_detail_vimeo[0].thumbnail_link;
      }
      return null;
    },
    badgeImageFileId() {
      if (this.learningUnit && this.learningUnit.badge_image && this.learningUnit.badge_image[0]) {
        return this.learningUnit.badge_image[0].id;
      }
      return null;
    },
    contentMediaFileId() {
      if (
        this.learningUnit &&
        this.learningUnit.content_media &&
        this.learningUnit.content_media[0]
      ) {
        return this.learningUnit.content_media[0].id;
      }
      return null;
    },
    contentMediaVideoThumbnailSrc() {
      if (
        this.learningUnit &&
        this.learningUnit.content_media_vimeo &&
        this.learningUnit.content_media_vimeo[0]
      ) {
        return this.learningUnit.content_media_vimeo[0].thumbnail_link;
      }
      return null;
    },
    developerMediaFileId() {
      if (
        this.learningUnit &&
        this.learningUnit.developer_media &&
        this.learningUnit.developer_media[0]
      ) {
        return this.learningUnit.developer_media[0].id;
      }
      return null;
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    async fetchLearningUnit() {
      if (!this.learningUnitId) return;
      try {
        this.fetching = true;

        await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);

        if (this.learningUnit && !this.learningUnit.is_published) {
          return this.$router.push({
            name: 'not-found'
          });
        }
      } catch (error) {
        return this.$router.push({
          name: 'not-found'
        });
      } finally {
        this.fetching = false;
      }
    },

    async fetchPermissionApply() {
      if (!this.user) return;

      if (!this.learningUnitId) return;

      this.checkingEligible = true;
      this.eligible = true;
      this.eligibleMessage = null;

      try {
        const {
          response: {
            data: { eligible }
          }
        } = await LearningUnit.api().checkPermissionApply(this.learningUnitId);

        this.eligible = eligible;
      } catch (error) {
        this.eligible = false;
        this.eligibleMessage = error.response.data.message;
      } finally {
        this.checkingEligible = false;
      }
    },

    async fetchApply() {
      if (!this.userId) return;

      try {
        this.applyFetching = true;
        await Application.api().find({
          user: this.userId,
          learning_unit: this.learningUnitId
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.applyFetching = false;
      }
    },

    async fetchInterest() {
      this.interestFetching = true;
      if (!this.userId) {
        this.interestFetching = false;
        return;
      }

      try {
        await Interest.api().findOneByLearner(this.learningUnitId);
      } catch (error) {
        console.log('error: ', error);
      }

      this.interestFetching = false;
    },

    async init() {
      await Promise.all([
        this.fetchLearningUnit(),
        this.fetchApply(),
        this.fetchInterest(),
        this.fetchPermissionApply()
      ]);

      if (this.$route.query.action === 'redeem') {
        if (this.eligible) {
          this.onClickRedeemCode();
        }
      }
    },

    scrollToMcVerify() {
      const wrapper = this.$refs['card_mc-detail-verify'];

      if (wrapper && wrapper.$el) {
        wrapper.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    },

    goToSignInPageWithRedirect() {
      const previousRoute = this.$router.resolve({
        ...this.$route,
        params: {
          learningUnitId: this.learningUnitId
        }
      });

      this.$router.push({
        name: 'SignIn',
        query: {
          previousPath: previousRoute.href
        }
      });
    },

    onClickRedeemCode() {
      if (!this.user) return this.goToSignInPageWithRedirect();

      this.activeModalRedeem = true;
    },
    onCloseModalRedeem() {
      this.activeModalRedeem = false;
      this.fetchApply();
    }
  }
};
</script>

<style lang="scss" scoped>
.img {
  &__badge {
    height: auto;
    max-width: 148px;
    width: 100%;
  }

  &__detail_image {
    max-height: 370px;
    border-radius: 10.4px;
  }

  &__content_image {
    max-height: 321px;
    max-width: 100%;
    width: 568px;
    border-radius: 10.4px;
  }

  &__developer_image {
    // max-height: 374px;
    // max-width: 100%;
    // width: 568px;
    border-radius: 10.4px;
  }
}

::v-deep .nav-link {
  color: #ffffff99;
  position: relative;
  transition: all 0.2s ease-in-out;
  padding: 0rem 1.5rem 0.7rem 0rem;

  &.active {
    color: #ffff;
    background: transparent !important;
  }
}

::v-deep .divider {
  background: #ffff !important;
  left: 0rem !important;
  width: calc(100% - 1.5rem) !important;
}

.tab__detail-mc {
  height: 490px;
  overflow-y: auto;
}

.tab__detail-mc::-webkit-scrollbar-track {
  border: none;
  padding: 2px 0;
  background-color: transparent;
}

.tab__detail-mc::-webkit-scrollbar {
  width: 3px;
}

.tab__detail-mc::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #bebebc;
  border: none;
}

.box__content {
  border: 1px solid #d8d8e0;
  border-radius: 10.4px;
  overflow-y: auto;
  max-height: 298px;
  padding: 1rem;
}

::v-deep .container__preview-video-detail iframe {
  max-height: 370px !important;
  max-width: 100% !important;
  background-color: black !important;
}

::v-deep .container__preview-video-content iframe {
  max-height: 321px !important;
  max-width: 100% !important;
  background-color: black !important;
}
</style>

<style lang="scss">
.container__page-explore-detail {
  .button__redeem-code.btn-link {
    text-decoration: underline;
  }
  .button__redeem-code.btn-link:hover {
    text-decoration: none;
  }
}
.skills-tooltip.tooltip.b-tooltip {
  opacity: 1 !important;
}
.skills-tooltip {
  .tooltip-inner {
    background-color: #fff !important;
    line-height: 26px;
    padding: 14px;
  }
}
.col-md-10 {
  max-width: 85%;
}
</style>
